<template>
    <div>
        <v-list
            dense
            two-line
            :min-height="225"
            :max-height="225"
            style="overflow-y: auto"
        >
            <v-list-item-group
                :value="selectedSession"
                color="primary"
                @change="onSessionSelect"
            >
                <template v-for="(item, index) in sessions">
                    <v-list-item :key="index" class="align-center">
                        <v-list-item-avatar>
                            <v-icon
                                :class="
                                    item.selected
                                        ? 'primary--text'
                                        : 'primary--text text--lighten-2'
                                "
                                >mdi-calendar</v-icon
                            >
                        </v-list-item-avatar>
                        <v-list-item-content
                            class="justify-start text-start px-0 mx-0"
                        >
                            <v-list-item-title>
                                {{ item.name }}
                                <v-chip
                                    color="secondary lighten-1"
                                    class="ml-2"
                                    small
                                    v-if="item.is_current"
                                    >Current</v-chip
                                >
                            </v-list-item-title>
                            <v-list-item-subtitle
                                >{{ $dateFormat(item.start_date) }} -
                                {{
                                    $dateFormat(item.end_date)
                                }}</v-list-item-subtitle
                            >
                        </v-list-item-content>
                        <v-list-item-action>
                            <v-icon v-if="item.selected"
                                >mdi-check-circle</v-icon
                            >
                        </v-list-item-action>
                    </v-list-item>
                    <v-divider
                        :key="`divider-${index}`"
                        v-if="index < sessions.length - 1"
                    ></v-divider>
                </template>
            </v-list-item-group>
        </v-list>
    </div>
</template>
<script>
export default {
    name: "session-select",
    components: {},
    props: {
        sessions: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {};
    },
    computed: {
        selectedSession() {
            const selected = this.sessions.findIndex(
                (session) => session.selected
            );
            this.$emit("update-selected", this.sessions[selected]);
            return selected;
        },
        title() {
            return "Sessions";
        },
    },
    watch: {},
    methods: {
        onSessionSelect(index) {
            this.$emit("select-session", this.sessions[index]);
        },
    },
};
</script>

<style scoped>
</style>